"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDocumentSettingsFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("circle", { cx: 16, cy: 20.53, r: 1.5 }),
        React.createElement("path", { d: "M25.41 10L18 2.59V10h7.41z" }),
        React.createElement("path", { d: "M22 12h-6V2H6v28h20V12zm-2.5 8.53a3.59 3.59 0 01-.1.81l1.86 1.08-1 1.73-1.86-1.08a3.49 3.49 0 01-1.4.8V26h-2v-2.13a3.56 3.56 0 01-1.4-.8l-1.86 1.08-1-1.73 1.86-1.08a3.59 3.59 0 01-.1-.81 3.5 3.5 0 01.1-.8l-1.86-1.08 1-1.73L13.6 18a3.56 3.56 0 011.4-.8V15h2v2.2a3.49 3.49 0 011.4.8l1.86-1.08 1 1.73-1.86 1.08a3.5 3.5 0 01.1.8z" })));
}
exports.default = SvgDocumentSettingsFilled;
//# sourceMappingURL=DocumentSettingsFilled.js.map